import loadId from 'src/internal/shared/loadId';

import type {ObservabilityFns} from 'src/internal/shared/observability/types';
import type {
  ErrorData,
  ErrorDataAnalyticsReport,
  ErrorDataMetricsReport,
  ErrorDataSentryReport,
} from 'src/internal/telemetry/types';

export default function logHttp(
  type: 'GraphQL' | 'Fetch',
  observabilityFns: ObservabilityFns,
  errorData: ErrorData,
): void {
  const {analytics, errors, metrics} = observabilityFns || {};

  const page = '<unknown>'; // This should be `useRoute()[0].name`.

  const analyticsParams: ErrorDataAnalyticsReport = {
    error_code: errorData.errorCode,
    error_message: errorData.errorMessage,
    error_path: errorData.errorPath,
    network_duration: errorData.networkDuration,
    network_start: errorData.networkStart,
    network_end: errorData.networkEnd,
    network_status: errorData.networkStatus,
    network_action_id: errorData.networkActionId,
    network_request_id: errorData.networkRequestId,
    network_load_id: loadId,
    network_trace_id: errorData.networkTraceId,

    service: errorData.service,
    project: errorData.project,
    component: errorData.component,

    error_expected: errorData.errorExpected,
    error_muted: errorData.errorMuted,
    error_source: errorData.errorSource,

    operation_name: errorData.operationName,
    operation_tag: errorData.operationTag,
    operation_deduplicate: errorData.operationDeduplicate,
    operation_prefetch: errorData.operationPrefetch,
    operation_prefetch_hit: errorData.operationPrefetchHit,
  };

  const metricTags: ErrorDataMetricsReport = {
    service: errorData.service,
    project: errorData.project,
    component: errorData.component,
    page,
    owner: errorData.project,

    error_expected: errorData.errorExpected,
    error_muted: errorData.errorMuted,
    error_source: errorData.errorSource,

    operation_name: errorData.operationName,
    operation_tag: errorData.operationTag,
    operation_deduplicate: errorData.operationDeduplicate,
    operation_prefetch: errorData.operationPrefetch,
    operation_prefetch_hit: errorData.operationPrefetchHit,
  };

  // Report to Splunk and SFX.
  metrics?.increment('frontend.data.error', metricTags);
  analytics?.track('frontend.data.error', analyticsParams);

  // Report to Sentry.
  if (!errorData.errorExpected && !errorData.operationPrefetch) {
    const project = errorData.project;
    const muted = errorData.errorMuted;
    const errorMessage = `${type} error '${errorData.errorCode}' on operation '${errorData.operationName}'`;
    const method = muted ? errors.warning : errors.error;

    if (project !== '<unknown>') {
      const errorReportExtras: ErrorDataSentryReport = {
        ...errorData,
        networkLoadId: loadId,
        page,
      };

      method(errorMessage, {
        project,
        extras: errorReportExtras,
      });
    }
  }
}
